import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=1f3fa7f0&scoped=true&"
import script from "./FormTitle.vue?vue&type=script&lang=ts&"
export * from "./FormTitle.vue?vue&type=script&lang=ts&"
import style0 from "./FormTitle.vue?vue&type=style&index=0&id=1f3fa7f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3fa7f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
